import xmlFormatter from "xml-formatter";
import { useMemo } from "react";
import "../assets/stylesheets/xml.css";

export const XMLViewer = ({ content }: { content: string }) => {
  const formattedXML = useMemo(() => {
    try {
      return xmlFormatter(content, {
        indentation: "  ",
        collapseContent: true,
        lineSeparator: "\n",
      });
    } catch (error) {
      console.warn("Failed to format XML content, rendering raw text instead", error);
      return content;
    }
  }, [content]);

  return (
    <pre className="xml-content xml-border w-full min-w-0">
      {formattedXML}
    </pre>
  );
};
